import React from 'react';
import {Box, Container, List, ListItem, ListItemIcon, Paper, Typography} from '@mui/material';
import RegisterButton from "./RegisterButton";
import {Diamond} from "@mui/icons-material";

const AboutCourse: React.FC = () => {
    const iconStyle = {
        minWidth: 40,
        mt: 0.5,
    };

    return (
        <Container maxWidth={false} disableGutters>
            <Box
                sx={{
                    pt: 4,
                    pb: 8,
                    px: {xs: 3, md: 8},
                    position: 'relative',
                    overflow: 'hidden',
                    zIndex: 1,
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundImage: `url('about/naukma-poster.webp')`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        filter: 'blur(15px)',
                        zIndex: -2,
                    },
                    '&::after': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        background: `linear-gradient(to bottom, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%)`,
                        zIndex: -1,
                    },
                }}
            >
                <Typography
                    variant="h1"
                    sx={{
                        fontFamily: 'Kyiv Type Serif',
                        fontWeight: 700,
                        fontSize: '48px',
                        mb: 4,
                    }}
                >
                    KMA Winter School
                </Typography>

                <Typography
                    sx={{
                        fontFamily: 'Kyiv Type Sans',
                        fontSize: '20px',
                        fontWeight: 400,
                        mb: 3,
                        maxWidth: '460px',
                    }}
                >
                    Програма для учнів і учениць 11 класів, які хочуть відчути атмосферу студентського життя провідного університету України
                </Typography>

                <RegisterButton
                    text={'Зареєструватися'}
                    margin={'0'}
                    padding={'12px 24px'}
                />
            </Box>

            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: {xs: '1fr', md: 'repeat(4, 1fr)'},
                    gap: 3,
                    px: {xs: 3, md: 8},
                    py: 4
                }}
            >
                <Paper
                    elevation={0}
                    sx={{
                        bgcolor: '#DEE8FF',
                        p: 3,
                        borderRadius: '8px',
                        textAlign: 'center'
                    }}
                >
                    <Typography sx={{fontFamily: 'Kyiv Type Sans', fontWeight: 700, mb: 1}}>
                        Тривалість:
                    </Typography>
                    <Typography sx={{fontFamily: 'Kyiv Type Sans', fontWeight: 400}}>
                        3 дні
                    </Typography>
                    <Typography sx={{fontFamily: 'Kyiv Type Sans', fontWeight: 300}}>
                        (8-10 січня 2026)
                    </Typography>
                </Paper>

                <Paper
                    elevation={0}
                    sx={{
                        bgcolor: '#DEE8FF',
                        p: 3,
                        borderRadius: '8px',
                        textAlign: 'center'
                    }}
                >
                    <Typography sx={{fontFamily: 'Kyiv Type Sans', fontWeight: 700, mb: 1}}>
                        Місце проведення:
                    </Typography>
                    <Typography sx={{fontFamily: 'Kyiv Type Sans', fontWeight: 400}}>
                        Кампус
                    </Typography>
                    <Typography sx={{fontFamily: 'Kyiv Type Sans', fontWeight: 300}}>
                        Києво-Могилянської академії (Київ)
                    </Typography>
                </Paper>

                <Paper
                    elevation={0}
                    sx={{
                        bgcolor: '#DEE8FF',
                        p: 3,
                        borderRadius: '8px',
                        textAlign: 'center'
                    }}
                >
                    <Typography sx={{fontFamily: 'Kyiv Type Sans', fontWeight: 700, mb: 1}}>
                        Кількість учасників:
                    </Typography>
                    <Typography sx={{fontFamily: 'Kyiv Type Sans', fontWeight: 400}}>
                        До 25 осіб в групі
                    </Typography>
                    <Typography sx={{fontFamily: 'Kyiv Type Sans', fontWeight: 300}}>
                        (з будь-якого регіону України)
                    </Typography>
                </Paper>

                <Paper
                    elevation={0}
                    sx={{
                        bgcolor: '#DEE8FF',
                        p: 3,
                        borderRadius: '8px',
                        textAlign: 'center'
                    }}
                >
                    <Typography sx={{fontFamily: 'Kyiv Type Sans', fontWeight: 700, mb: 1}}>
                        Вартість:
                    </Typography>
                    <Typography sx={{fontFamily: 'Kyiv Type Sans', fontWeight: 400}}>
                        Організаційний внесок 1950 грн
                    </Typography>
                </Paper>
            </Box>

            <Box
                sx={{
                    width: '100%',
                    background: '#DEE8FF',
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    overflow: 'hidden',
                    padding: 0,
                }}
            >
                <Box
                    id="about-course"
                    sx={{
                        width: {xs: '100%', md: '40%'},
                        p: {xs: 2, md: 6},
                        textAlign: 'center',
                    }}
                >
                    <Typography
                        variant="h2"
                        component="h1"
                        gutterBottom
                        sx={{
                            fontFamily: 'Kyiv Type Serif',
                            fontSize: { xs: '2.5rem', md: '4rem' },
                            fontWeight: 700,
                            mb: 4,
                            textAlign: 'center',
                        }}
                    >
                        Про програму:
                    </Typography>

                    <List sx={{width: '100%', padding: 0}}>
                        <ListItem alignItems="flex-start" sx={{mb: 2, p: 0}}>
                            <ListItemIcon sx={iconStyle}>
                                <Diamond />
                            </ListItemIcon>
                            <Typography
                                sx={{
                                    fontFamily: 'Kyiv Type Sans',
                                    fontSize: '1.125rem',
                                    fontWeight: 400,
                                    textAlign: 'left',
                                }}
                            >
                                Академічні сесії з викладачами Могилянки, де можна зануритися в реальне навчання
                            </Typography>
                        </ListItem>

                        <ListItem alignItems="flex-start" sx={{mb: 2, p: 0}}>
                            <ListItemIcon sx={iconStyle}>
                                <Diamond />
                            </ListItemIcon>
                            <Typography
                                sx={{
                                    fontFamily: 'Kyiv Type Sans',
                                    fontSize: '1.125rem',
                                    fontWeight: 400,
                                    textAlign: 'left',
                                }}
                            >
                                Практичні воркшопи, щоб прокачати навички, корисні при вступі та навчанні
                            </Typography>
                        </ListItem>

                        <ListItem alignItems="flex-start" sx={{mb: 2, p: 0}}>
                            <ListItemIcon sx={iconStyle}>
                                <Diamond />
                            </ListItemIcon>
                            <Typography
                                sx={{
                                    fontFamily: 'Kyiv Type Sans',
                                    fontSize: '1.125rem',
                                    fontWeight: 400,
                                    textAlign: 'left',
                                }}
                            >
                                Інтерактивні заходи, що допоможуть ближче познайомитися зі студентським життям
                            </Typography>
                        </ListItem>

                        <ListItem alignItems="flex-start" sx={{mb: 4, p: 0}}>
                            <ListItemIcon sx={iconStyle}>
                                <Diamond />
                            </ListItemIcon>
                            <Typography
                                sx={{
                                    fontFamily: 'Kyiv Type Sans',
                                    fontSize: '1.125rem',
                                    fontWeight: 400,
                                    textAlign: 'left',
                                }}
                            >
                                Поради, як краще підготуватись до НМТ та обрати майбутню спеціальність
                            </Typography>
                        </ListItem>
                    </List>
                </Box>

                <Box
                    component="img"
                    src="about/skovoroda.webp"
                    alt="Decorative"
                    sx={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        height: 'auto',
                        maxWidth: { xs: 0, md: '30%', lg: '40%' },
                        display: { xs: 'none', md: 'block' },
                    }}
                />
                <Box
                    component="img"
                    src="about/naukma-small.webp"
                    alt="Decorative"
                    sx={{
                        position: 'absolute',
                        bottom: 0,
                        right: 0,
                        height: 'auto',
                        maxWidth: { xs: 0, md: '30%', lg: '40%' },
                        display: { xs: 'none', md: 'block' },
                    }}
                />
            </Box>
        </Container>
    );
};

export default AboutCourse;